// test
export const increment = ({commit}) => {
  commit('INCREMENT');
};
// test
export const updataVuexUserInfo = ({commit}, userInfo) => {
  commit('updataVuexUserInfo', userInfo);
};
export const showLoginFlay = ({commit}) => {
  commit('showLoginFlay');
};
export const hideLoginFlay = ({commit}) => {
  commit('hideLoginFlay');
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js